export const User = {
    userId: "userId",
    role: "role",
    token: "token",
    exp: "exp"
};